import { gatewayInstance } from "../../axiosInstance";
import { SERVICE_ENDPOINT } from "../../const";
export const getCreditDebitNoteEvInvDetails = async (eihId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/credit-debit/by-id/${eihId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const countHeaders = async (eihId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/credit-debit/count-headers/${eihId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getCreditDebitHeaderWithDetails = async (dcrId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/credit-debit/by-dcr-id/${dcrId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getCreditDebitDraftWithDetails = async (dhdId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/credit-debit/by-dhd-id/${dhdId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const createCreditDebitNote = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/credit-debit/create`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const createCreditDebitDraft = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/credit-debit/create-draft`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const calculateCreditDebitTax = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/credit-debit/calc-tax`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateCreditDebitNote = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `/financeservice/credit-debit/update`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const updateCreditDebitDraft = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `/financeservice/credit-debit/update-draft`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const updatePrintState = async (dcrId) => {
  try {
    const response = await gatewayInstance.put(
      `/financeservice/credit-debit/update-print/${dcrId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updatePrePrintState = async (dcrId) => {
  try {
    const response = await gatewayInstance.put(
      `/financeservice/credit-debit/update-pre-print/${dcrId}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getPrintState = async (dcrId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/credit-debit/get-print/${dcrId}`
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getPrePrintState = async (dcrId) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/credit-debit/get-pre-print/${dcrId}`
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const updateCreditDebitRemark = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `/financeservice/credit-debit/update-remark`,
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const filterCreditDebitNote = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/credit-debit/filter-list`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const filterCreditDebitDraft = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/credit-debit/filter-draft-list`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const deleteCreditDebitDraft = async (dhdId) => {
  try {
    const response = await gatewayInstance.put(
      `/financeservice/credit-debit/inactive-draft/${dhdId}`
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const deleteCreditDebitNote = async (dcrId) => {
  try {
    const response = await gatewayInstance.put(
      `/financeservice/credit-debit/delete-note/${dcrId}`
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

/**
 * Download Inspection Document API
 * @param {Object} payload - The data to be sent in the API request
 * @param {string} reportType - The type of report to generate (e.g., "pdf")
 * @returns {Promise<Blob>} - A Blob containing the generated report
 */
export const downloadCreditDebitDocument = async (
  payload,
  reportType = "pdf"
) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/report/credit-debit/generate?reportType=${reportType}`,
      payload,
      { responseType: "blob" } // To handle binary PDF file responses
    );

    return response.data; // Return the Blob directly
  } catch (error) {
    console.error("Error downloading credit-debit document:", error);
    throw error;
  }
};


export const downloadCreditDebitPrePrintedDocument = async (
  payload,
  reportType = "pdf"
) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/report/credit-debit/generate/pre-printed?reportType=${reportType}`,
      payload,
      { responseType: "blob" } // To handle binary PDF file responses
    );

    return response.data; // Return the Blob directly
  } catch (error) {
    console.error("Error downloading credit-debit document:", error);
    throw error;
  }
};
